import React from 'react';
import { ListGroupItem } from 'reactstrap';

import RichText from '../../Common/RichText/RichText';
import ImageExpand from '../ImageExpand';

class MCAnswer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      correct: false,
      clicked: false,
    };
  }

  componentDidUpdate() {
    if (this.state.clicked === true && this.props.checkAnswered() === false) {
      this.setState({ clicked: false });
    }
  }

  doCheckAnswer = () => {
    if (this.props.alreadyAnswered) return null;
    if (this.props.fromReview) return null;
    if (
      this.props.checkAnswered() === false ||
      this.props.allowToChangeAnswer === true
    ) {
      this.props.doAnswer(this.props.correct);
    } else {
      return null;
    }
    // I answer the block so I cannot do it again
    // change state depending on prop
    if (this.props.correct === true) {
      this.setState({ correct: true, clicked: true });
    } else {
      this.setState({ correct: false, clicked: true });
    }
    // this is not needed on daily20quiz
    if (this.props.setPreviousAnswerClicked) {
      this.props.setPreviousAnswerClicked(this.props.answer);
    }
    this.props.selectAnswer(this.props.answer.id);

    return null;
  };

  renderSymbols = (text) => {
    const isNewQuestion = /<\/?[a-z][\s\S]*>/i.test(text);
    let result = text;
    if (!isNewQuestion) {
      result = result.replace(/</g, '&lt;');
      result = result.replace(/>/g, '&gt;');
    }
    return result;
  };

  render() {
    // alreadyAnswered = ID SELECTED ANSWERED

    // Refactor when final: In case we have to customize a lot this is a better solution than adding ifs
    const answeredCorrect = (
      <div className="solution d-flex flex-row align-items-center">
        <i className="ml-1 success icon-check2" />
      </div>
    );
    const answeredWrong = (
      <div className="solution d-flex flex-row align-items-center">
        <em>Your Answer</em> <i className="ml-1 danger icon-close" />
      </div>
    );
    const answeredWrongHelper = (
      <div className="solution d-flex flex-row align-items-center">
        <em>Correct Answer</em> <i className="ml-1 success icon-check2" />
      </div>
    );
    let badge = '';
    let listClasses = 'd-flex flex-row justify-content-between';
    if (this.props.allowToChangeAnswer !== true) {
      if (
        this.state.clicked ||
        this.props.alreadyAnswered === this.props.answer.id
      ) {
        listClasses += ' selected';
        if (this.state.correct) {
          badge = answeredCorrect;
        } else {
          badge = answeredWrong;
        }
      }

      if (this.props.showPreviousAnswer) {
        // Previous answer handling
        if (this.props.answer.id === this.props.previousAnswerClicked.id) {
          if (this.props.previousAnswerClicked.correct) {
            badge = answeredCorrect;
          } else {
            badge = answeredWrong;
          }
        }
      }

      if (
        (this.props.checkAnswered() &&
          this.props.markCorrect &&
          this.props.correct) ||
        (this.props.alreadyAnswered && this.props.correct)
      ) {
        badge = answeredWrongHelper;
      }
    } else {
      if (this.props.selectedAnswer) {
        listClasses += ' selected';
      }
    }

    const questionClickedStyle = this.props.correct
      ? 'correctAnswerStyle'
      : 'incorrectAnswerStyle';

    return (
      <>
        <ListGroupItem
          onClick={this.doCheckAnswer}
          className={listClasses}
          data-test={`answer-button-${this.props.char}`}
        >
          <div className="d-flex" style={{ cursor: 'pointer' }}>
            <b className="ml-2 mr-3">{this.props.char}.</b>{' '}
            <div>
              <RichText
                className={
                  this.props.questionClicked &&
                  this.props.allowToChangeAnswer !== true
                    ? questionClickedStyle
                    : ''
                }
                html={this.renderSymbols(this.props.text || '')}
              />
              <div>
                <ImageExpand imageUrl={this.props.answer.imageUrl} />
              </div>
            </div>
          </div>
          {badge}
        </ListGroupItem>
      </>
    );
  }
}

export default MCAnswer;
